import { createFileRoute } from '@tanstack/react-router'
import {
  OrdersSection,
  ordersLoader,
  validateOrdersSearch,
  type OrdersSearchParams,
} from '@spcc/domains/orders'

export const Route = createFileRoute('/orders')({
  validateSearch: (search): OrdersSearchParams => validateOrdersSearch(search),
  loaderDeps: ({ search }) => {
    // Exclude pagination and drawer params so that page/pageSize changes driven
    // by the component's pagination UI do NOT re-trigger the loader.
    // Previously, every replaceState call (including component-driven page
    // changes) caused the loader to re-run. The loader for a stale URL like
    // ?status=delivered (page=1) would fire *after* Redux already had page=3,
    // find page:1 ≠ page:3, and reset pagination — causing a second request.
    const { page, pageSize, openOrderNumber, ...filterSearch } = search
    return { search: filterSearch }
  },
  loader: async ({ context, location }) => {
    // Use the full location.search (includes page/pageSize) so deep links like
    // ?page=3&status=delivered correctly initialize filter state on first load.
    // The loader only re-runs when filter fields change (per loaderDeps above),
    // not on pagination-only URL changes.
    return ordersLoader({ context, initialSearch: location.search as OrdersSearchParams })
  },
  component: OrdersPage,
})

function OrdersPage() {
  return <OrdersSection />
}
